import React, { useEffect, useContext, useState } from 'react';

import { LoginContext } from '../../hooks/context/LoginContext';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Formulario from '../../componentes/formulario/Formulario';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import { Alert } from '../../componentes/ui/Alert';
import MiSelect from '../../componentes/formulario/MiSelect';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import TextArea from '../../componentes/formulario/TextArea';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Spinner from 'react-bootstrap/Spinner';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { getTitle, getDecodedCookie } from '../../helpers/helperApp';

import { Fragment } from 'react';

function AppMsg(props){

    const cookies = new Cookies();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ estadoFormPrin, saveEstadoFormPrin ] = useState("");
    const [ estadoFormHijo, saveEstadoFormHijo ] = useState("");

    // ***** Custom Hook - Lógica de los formularios *****
    const { registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin, saveFormularioHijo , handleInputForm, handleLastReg, handleEditRegPrin, loadingTable, saveLoadingTable, loadReg, regIniciales, handleDeleteItemPrin, handleSubmitPrin, resetFormPrin, handleSelectFormPrin } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{   
                    document.title = getTitle(confPantalla.config.trad, confPantalla.appmsg.title);                                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true); 
                        saveEstadoFormPrin(confPantalla.appmsg.padre.estadoform);
                        saveEstadoFormHijo(confPantalla.appmsg.hijo.estadoform);                              
                        // ***** Carga inicial de registros *****
                        if( registrosPrin ){
                            if( registrosPrin.length === 0 ){
                                saveLoadingTable(true);
                                regIniciales(saveRegistrosPrin, confPantalla.appmsg.padre.urls);
                                saveFormularioPrin(confPantalla.appmsg.padre.modelform);
                                saveFormularioHijo(confPantalla.appmsg.hijo.modelform);     
                            }
                        }                                             
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");
        } 

    },[confPantalla])
 

    return(
        <div className="App wrapper">
             <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
                {
                    !loadReg ?
                        <Alert fondo={true} />
                    :
                        <Alert />
                }                                
            </div>    
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                        <Section titulo={ confPantalla.appmsg.section.titulo } icono={ confPantalla.appmsg.section.icono } col={ confPantalla.appmsg.section.col } idPrin={ formularioPrin.id } wiki={ confPantalla.appmsg.section.wiki } >
                            <Formulario 
                                        estadoForm= { estadoFormPrin }
                                        loading=    { loadReg ? true : false }
                                        btnNew={ confPantalla.appmsg.padre.btnform.new }
                                        btnSave={ confPantalla.appmsg.padre.btnform.save }
                                        btnSaveAndNew={ confPantalla.appmsg.padre.btnform.saveandnew }
                                        btnDelete={ confPantalla.appmsg.padre.btnform.delete }
                                        btnClone={ confPantalla.appmsg.padre.btnform.clone }
                                        handleSubmit = { e => handleSubmitPrin(e, confPantalla.appmsg.padre.urls, confPantalla.appmsg.padre.modelform, confPantalla.appmsg.padre.tabla, confPantalla.appmsg.hijo.modelform, confPantalla.appmsg.title) }  
                                        formulario = { formularioPrin } 
                                        resetForm = { e => resetFormPrin(confPantalla.appmsg.padre.modelform, true, confPantalla.appmsg.padre.tabla) } 
                                        handleDeleteItem = { e => handleDeleteItemPrin(undefined, confPantalla.appmsg.padre.urls, confPantalla.appmsg.padre.modelform, confPantalla.appmsg.padre.tabla, confPantalla.appmsg.title) } 
                            >         
                                <FormRow>
                                    <MiSelect  
                                        estadoForm=  { estadoFormPrin }
                                        val=         { formularioPrin.msg_idest  }   
                                        loading=     { loadReg ? true : false }
                                        id=          { confPantalla.appmsg.padre.controles.msg_idest.id }    
                                        name=        { confPantalla.appmsg.padre.controles.msg_idest.name }   
                                        label=       { confPantalla.appmsg.padre.controles.msg_idest.label }    
                                        placeholder= { confPantalla.appmsg.padre.controles.msg_idest.placeholder }
                                        col=         { confPantalla.appmsg.padre.controles.msg_idest.col } 
                                        isClearable= { confPantalla.appmsg.padre.controles.msg_idest.isclearable }
                                        isSearchable={ confPantalla.appmsg.padre.controles.msg_idest.issearchable }
                                        dataType=    { confPantalla.appmsg.padre.controles.msg_idest.datatype }
                                        data=        { confPantalla.appmsg.padre.controles.msg_idest.data }
                                        required=    { confPantalla.appmsg.padre.controles.msg_idest.required } 
                                        disabled=  { confPantalla.appmsg.padre.controles.msg_idest.disabled }
                                        readOnly =   { confPantalla.appmsg.padre.controles.msg_idest.readonly }
                                        disablethisid={confPantalla.appmsg.padre.controles.msg_idest.disablethisid}
                                        disableids={confPantalla.appmsg.padre.controles.msg_idest.disableids}
                                        formulario= { formularioPrin }   
                                        change= { handleSelectFormPrin }
                                    />
                                </FormRow>
                                <FormRow clases="" >
                                    <MiSelect  
                                        estadoForm=  { estadoFormPrin }
                                        val=         { formularioPrin.from_idage  }   
                                        loading=     { loadReg ? true : false }
                                        id=          { confPantalla.appmsg.padre.controles.from_idage.id }    
                                        name=        { confPantalla.appmsg.padre.controles.from_idage.name }   
                                        label=       { confPantalla.appmsg.padre.controles.from_idage.label }    
                                        placeholder= { confPantalla.appmsg.padre.controles.from_idage.placeholder }
                                        col=         { confPantalla.appmsg.padre.controles.from_idage.col } 
                                        isClearable= { confPantalla.appmsg.padre.controles.from_idage.isclearable }
                                        isSearchable={ confPantalla.appmsg.padre.controles.from_idage.issearchable }
                                        dataType=    { confPantalla.appmsg.padre.controles.from_idage.datatype }
                                        data=        { confPantalla.appmsg.padre.controles.from_idage.data }
                                        required=    { confPantalla.appmsg.padre.controles.from_idage.required } 
                                        disabled=  { confPantalla.appmsg.padre.controles.from_idage.disabled }
                                        readOnly =   { confPantalla.appmsg.padre.controles.from_idage.readonly }
                                        disablethisid={confPantalla.appmsg.padre.controles.from_idage.disablethisid}
                                        disableids={confPantalla.appmsg.padre.controles.from_idage.disableids}
                                        formulario= { formularioPrin }   
                                        change= { handleSelectFormPrin }
                                    />
                                    <MiSelect  
                                        estadoForm=  { estadoFormPrin }
                                        val=         { formularioPrin.to_idage  }   
                                        loading=     { loadReg ? true : false }
                                        id=          { confPantalla.appmsg.padre.controles.to_idage.id }    
                                        name=        { confPantalla.appmsg.padre.controles.to_idage.name }   
                                        label=       { confPantalla.appmsg.padre.controles.to_idage.label }    
                                        placeholder= { confPantalla.appmsg.padre.controles.to_idage.placeholder }
                                        col=         { confPantalla.appmsg.padre.controles.to_idage.col } 
                                        isClearable= { confPantalla.appmsg.padre.controles.to_idage.isclearable }
                                        isSearchable={ confPantalla.appmsg.padre.controles.to_idage.issearchable }
                                        dataType=    { confPantalla.appmsg.padre.controles.to_idage.datatype }
                                        data=        { confPantalla.appmsg.padre.controles.to_idage.data }
                                        required=    { confPantalla.appmsg.padre.controles.to_idage.required } 
                                        disabled=  { confPantalla.appmsg.padre.controles.to_idage.disabled }
                                        readOnly =   { confPantalla.appmsg.padre.controles.to_idage.readonly }
                                        disablethisid={confPantalla.appmsg.padre.controles.to_idage.disablethisid}
                                        disableids={confPantalla.appmsg.padre.controles.to_idage.disableids}
                                        formulario= { formularioPrin }   
                                        change= { handleSelectFormPrin }
                                    /> 
                                </FormRow>
                                <FormRow>
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.send_date }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.appmsg.padre.controles.send_date.id }   
                                        type=       { confPantalla.appmsg.padre.controles.send_date.type }  
                                        name=       { confPantalla.appmsg.padre.controles.send_date.name }   
                                        label=      { confPantalla.appmsg.padre.controles.send_date.label }                                                       
                                        placeholder={ confPantalla.appmsg.padre.controles.send_date.placeholder }    
                                        col=        { confPantalla.appmsg.padre.controles.send_date.col } 
                                        required=   { confPantalla.appmsg.padre.controles.send_date.required }
                                        readonly=   { confPantalla.appmsg.padre.controles.send_date.readonly }
                                        disabled=   { confPantalla.appmsg.padre.controles.send_date.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    />
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.rem_date }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.appmsg.padre.controles.rem_date.id }   
                                        type=       { confPantalla.appmsg.padre.controles.rem_date.type }  
                                        name=       { confPantalla.appmsg.padre.controles.rem_date.name }   
                                        label=      { confPantalla.appmsg.padre.controles.rem_date.label }                                                       
                                        placeholder={ confPantalla.appmsg.padre.controles.rem_date.placeholder }    
                                        col=        { confPantalla.appmsg.padre.controles.rem_date.col } 
                                        required=   { confPantalla.appmsg.padre.controles.rem_date.required }
                                        readonly=   { confPantalla.appmsg.padre.controles.rem_date.readonly }
                                        disabled=   { confPantalla.appmsg.padre.controles.rem_date.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    />
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.exp_date }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.appmsg.padre.controles.exp_date.id }   
                                        type=       { confPantalla.appmsg.padre.controles.exp_date.type }  
                                        name=       { confPantalla.appmsg.padre.controles.exp_date.name }   
                                        label=      { confPantalla.appmsg.padre.controles.exp_date.label }                                                       
                                        placeholder={ confPantalla.appmsg.padre.controles.exp_date.placeholder }    
                                        col=        { confPantalla.appmsg.padre.controles.exp_date.col } 
                                        required=   { confPantalla.appmsg.padre.controles.exp_date.required }
                                        readonly=   { confPantalla.appmsg.padre.controles.exp_date.readonly }
                                        disabled=   { confPantalla.appmsg.padre.controles.exp_date.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    />
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.read_date }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.appmsg.padre.controles.read_date.id }   
                                        type=       { confPantalla.appmsg.padre.controles.read_date.type }  
                                        name=       { confPantalla.appmsg.padre.controles.read_date.name }   
                                        label=      { confPantalla.appmsg.padre.controles.read_date.label }                                                       
                                        placeholder={ confPantalla.appmsg.padre.controles.read_date.placeholder }    
                                        col=        { confPantalla.appmsg.padre.controles.read_date.col } 
                                        required=   { confPantalla.appmsg.padre.controles.read_date.required }
                                        readonly=   { confPantalla.appmsg.padre.controles.read_date.readonly }
                                        disabled=   { confPantalla.appmsg.padre.controles.read_date.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    />
                                </FormRow>
                                <FormRow>                                    
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.idreg }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.appmsg.padre.controles.idreg.id }   
                                        type=       { confPantalla.appmsg.padre.controles.idreg.type }  
                                        name=       { confPantalla.appmsg.padre.controles.idreg.name }   
                                        label=      { confPantalla.appmsg.padre.controles.idreg.label }                                                       
                                        placeholder={ confPantalla.appmsg.padre.controles.idreg.placeholder }    
                                        col=        { confPantalla.appmsg.padre.controles.idreg.col } 
                                        required=   { confPantalla.appmsg.padre.controles.idreg.required }
                                        readonly=   { confPantalla.appmsg.padre.controles.idreg.readonly }
                                        disabled=   { confPantalla.appmsg.padre.controles.idreg.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    />
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.tab }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.appmsg.padre.controles.tab.id }   
                                        type=       { confPantalla.appmsg.padre.controles.tab.type }  
                                        name=       { confPantalla.appmsg.padre.controles.tab.name }   
                                        label=      { confPantalla.appmsg.padre.controles.tab.label }                                                       
                                        placeholder={ confPantalla.appmsg.padre.controles.tab.placeholder }    
                                        col=        { confPantalla.appmsg.padre.controles.tab.col } 
                                        required=   { confPantalla.appmsg.padre.controles.tab.required }
                                        readonly=   { confPantalla.appmsg.padre.controles.tab.readonly }
                                        disabled=   { confPantalla.appmsg.padre.controles.tab.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    /> 
                                    <MiSelect  
                                        estadoForm=  { estadoFormPrin }
                                        val=         { formularioPrin.idloc  }   
                                        loading=     { loadReg ? true : false }
                                        id=          { confPantalla.appmsg.padre.controles.idloc.id }    
                                        name=        { confPantalla.appmsg.padre.controles.idloc.name }   
                                        label=       { confPantalla.appmsg.padre.controles.idloc.label }    
                                        placeholder= { confPantalla.appmsg.padre.controles.idloc.placeholder }
                                        col=         { confPantalla.appmsg.padre.controles.idloc.col } 
                                        isClearable= { confPantalla.appmsg.padre.controles.idloc.isclearable }
                                        isSearchable={ confPantalla.appmsg.padre.controles.idloc.issearchable }
                                        dataType=    { confPantalla.appmsg.padre.controles.idloc.datatype }
                                        data=        { confPantalla.appmsg.padre.controles.idloc.data }
                                        required=    { confPantalla.appmsg.padre.controles.idloc.required } 
                                        disabled=  { confPantalla.appmsg.padre.controles.idloc.disabled }
                                        readOnly =   { confPantalla.appmsg.padre.controles.idloc.readonly }
                                        disablethisid={confPantalla.appmsg.padre.controles.idloc.disablethisid}
                                        disableids={confPantalla.appmsg.padre.controles.idloc.disableids}
                                        formulario= { formularioPrin }   
                                        change= { handleSelectFormPrin }
                                    />
                                    <MiSelect  
                                        estadoForm=  { estadoFormPrin }
                                        val=         { formularioPrin.idinf  }   
                                        loading=     { loadReg ? true : false }
                                        id=          { confPantalla.appmsg.padre.controles.idinf.id }    
                                        name=        { confPantalla.appmsg.padre.controles.idinf.name }   
                                        label=       { confPantalla.appmsg.padre.controles.idinf.label }    
                                        placeholder= { confPantalla.appmsg.padre.controles.idinf.placeholder }
                                        col=         { confPantalla.appmsg.padre.controles.idinf.col } 
                                        isClearable= { confPantalla.appmsg.padre.controles.idinf.isclearable }
                                        isSearchable={ confPantalla.appmsg.padre.controles.idinf.issearchable }
                                        dataType=    { confPantalla.appmsg.padre.controles.idinf.datatype }
                                        data=        { confPantalla.appmsg.padre.controles.idinf.data }
                                        required=    { confPantalla.appmsg.padre.controles.idinf.required } 
                                        disabled=  { confPantalla.appmsg.padre.controles.idinf.disabled }
                                        readOnly =   { confPantalla.appmsg.padre.controles.idinf.readonly }
                                        disablethisid={confPantalla.appmsg.padre.controles.idinf.disablethisid}
                                        disableids={confPantalla.appmsg.padre.controles.idinf.disableids}
                                        formulario= { formularioPrin }   
                                        change= { handleSelectFormPrin }
                                    />
                                </FormRow>
                                <FormRow>
                                    <TextArea                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.msg_sub }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.appmsg.padre.controles.msg_sub.id }   
                                        name=       { confPantalla.appmsg.padre.controles.msg_sub.name }
                                        rows=       { confPantalla.appmsg.padre.controles.msg_sub.rows }      
                                        label=      { confPantalla.appmsg.padre.controles.msg_sub.label }                                                       
                                        placeholder={ confPantalla.appmsg.padre.controles.msg_sub.placeholder }    
                                        col=        { confPantalla.appmsg.padre.controles.msg_sub.col } 
                                        required=   { confPantalla.appmsg.padre.controles.msg_sub.required }
                                        readonly=   { confPantalla.appmsg.padre.controles.msg_sub.readonly }                                                
                                        disabled=   { confPantalla.appmsg.padre.controles.msg_sub.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    />
                                </FormRow>
                            </Formulario>                        
                            <MiDataTable
                                formulario={formularioPrin}  
                                estadoForm= { estadoFormPrin }
                                id={"claage"}
                                columnas={confPantalla.appmsg.padre.datatable.columns}
                                data={registrosPrin}
                                buttons={confPantalla.appmsg.padre.datatable.buttons}
                                ordering={confPantalla.appmsg.padre.datatable.ordering}
                                order={confPantalla.appmsg.padre.datatable.order}
                                searching={confPantalla.appmsg.padre.datatable.searching}
                                paging={confPantalla.appmsg.padre.datatable.paging}
                                select={confPantalla.appmsg.padre.datatable.select}
                                pagelength={confPantalla.appmsg.padre.datatable.pagelength}
                                handleEditReg= { e => handleEditRegPrin(e, confPantalla.appmsg.padre.urls, confPantalla.appmsg.hijo.urls, confPantalla.appmsg.padreshijos, confPantalla.appmsg.hijo.modelform, confPantalla.appmsg.padre.tabla) }
                                handleDeleteItem={ e => handleDeleteItemPrin(e, confPantalla.appmsg.padre.urls, confPantalla.appmsg.padre.modelform, confPantalla.appmsg.padre.tabla, confPantalla.appmsg.title) }
                                saveLoadingTable={ saveLoadingTable }
                                loadingTable={loadingTable}
                                columnactions={confPantalla.appmsg.padre.datatable.columnactions.title}
                                traduction={confPantalla.config.trad.components.datatable}
                            />                                                                                                             
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default AppMsg